// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2968":"e8551b68","3186":"b59138cb","3304":"847cf55f","3455":"86f843d5","5175":"c30cf7ca","7012":"061f1704","7903":"c42e1d69","8395":"847cf55f","8809":"5551a95d","9593":"4de2d34a","9812":"5e75dab5"}[chunkId] + ".chunk.css";
};